export const en = {
  'payments.page.title': 'Payments',
  'payments.page.description': 'Everything charged through the connected payment provider.',
  'payments.page.descriptionAt': 'Payments taken at {branches}. Online payments belong to no branch, so they are not listed.',
  'payments.anyStatus': 'Any status',
  'payments.clearFilters': 'Clear filters',
  'payments.empty.title': 'No payments',
  'payments.empty.description': 'Payments appear once members buy plans or you charge them here.',
  'payments.member': 'Member',
  'payments.description': 'Description',
  'payments.amount': 'Amount',
  'payments.provider': 'Provider',
  'payments.details': 'Details',
  'payments.syncResult': 'Provider status: {status}',
  'payments.refund.title': 'Refund payment',
  'payments.refund.upTo': 'Up to {amount} can be refunded.',
  'payments.refund.atMost': 'At most {amount} can be refunded',
  'payments.refund.positiveAmount': 'Enter a positive amount',
  'payments.refund.sentForApproval': 'Refund sent for approval',
  'payments.refund.declined': 'The payment provider declined the refund. Check the integration logs.',
  'payments.refund.failed': 'Refund failed',
  'payments.refund.completed': 'Refund completed',
  'payments.refund.sentToProvider': 'Refund sent to the provider',
  'payments.refund.hint.everyRefund': 'This gym approves every refund: this refund waits until an owner, admin or accountant other than you approves it, and no money moves before then.',
  'payments.refund.hint.above': 'Above the approval limit of {limit}: this refund waits until an owner, admin or accountant other than you approves it, and no money moves before then.',
  'payments.refund.hint.within': 'Within the approval limit of {limit}: this refund goes through as soon as you submit it.',
  'payments.refund.hint.cumulativeAbove': '{earlier} of this payment is already refunded or waiting, so its refunds come to {total}, above the approval limit of {limit}: this refund waits until an owner, admin or accountant other than you approves it, and no money moves before then.',
  'payments.refund.hint.cumulativeWithin': '{earlier} of this payment is already refunded or waiting, so its refunds come to {total}, within the approval limit of {limit}: this refund goes through as soon as you submit it.',
  'payments.refund.request': 'Request refund',
  'payments.refund.requestFull': 'Request full refund',
  'payments.refund.amountButton': 'Refund amount',
  'payments.refund.full': 'Refund in full',
  'payments.refund.endsRenewal': 'Refunding everything that is left takes back the renewed period and turns automatic renewal off.',
  'payments.refund.endsMembership': 'Refunding everything that is left cancels the membership this payment bought.',
  'payments.refund.amountLabel': 'Amount ({currency})',
  'payments.refund.amountHint': 'Leave empty to refund the full remaining amount.',
  'payments.refund.reasonHint': 'Optional, but it helps the approver decide quickly.',
  'payments.charge.button': 'Charge member',
  'payments.charge.title': 'Charge a member',
  'payments.charge.description': 'Creates an order for a plan and starts a payment with the connected provider.',
  'payments.charge.viewPayment': 'View payment',
  'payments.charge.create': 'Create payment',
  'payments.charge.sendMember': 'Send the member to the payment page to complete the purchase:',
  'payments.charge.copy': 'Copy',
  'payments.charge.open': 'Open',
  'payments.charge.paidNow': 'The payment completed immediately and the membership is active.',
  'payments.charge.noRedirect': 'No redirect was returned by the provider.',
  'payments.charge.ids': 'Order {order}… · Payment {payment}…',
  'payments.charge.plan': 'Plan',
  'paymentDetail.title': 'Payment',
  'paymentDetail.receipt': 'Receipt',
  'paymentDetail.invoice': 'Invoice',
  'paymentDetail.invoiceNumber': 'Invoice {number}',
  'paymentDetail.receiptNumber': 'Receipt {number}',
  'paymentDetail.paymentId': 'Payment {id}…',
  'paymentDetail.membership': 'Membership',
  'paymentDetail.syncStatus': 'Sync status',
  'paymentDetail.refund': 'Refund',
  'paymentDetail.providerReference': 'Provider reference',
  'paymentDetail.created': 'Created',
  'paymentDetail.paid': 'Paid',
  'paymentDetail.refunded': 'Refunded',
  'paymentDetail.pendingRefunds': 'Pending refunds',
  'paymentDetail.failure': 'Failure',
  'paymentDetail.recordedBy': 'Recorded by',
  'paymentDetail.selfService': 'Online / self-service',
  'paymentDetail.soldByChange': 'Change',
  'paymentDetail.soldByHint': 'This changes the whole purchase: every payment of it counts for the new seller.',
  'paymentDetail.soldByChanged': 'Seller changed',
  'paymentDetail.waiting': 'Waiting for the member to complete payment.',
  'paymentDetail.openPaymentPage': 'Open payment page',
  'paymentDetail.copyLink': 'Copy link',
  'paymentDetail.transactions': 'Transactions',
  'paymentDetail.noTransactions': 'No transactions recorded.',
  'paymentDetail.when': 'When',
  'paymentDetail.type': 'Type',
  'paymentDetail.reference': 'Reference',
  'paymentDetail.refunds': 'Refunds',
  'paymentDetail.noRefunds': 'No refunds.',
  'paymentDetail.noReason': 'No reason given',
  'paymentDetail.requested': 'Requested {requested}',
  'paymentDetail.requestedReviewed': 'Requested {requested} · Reviewed {reviewed}',
  'paymentDetail.reviewNote': 'Review note:',
  'enum.paymentTransactionType.CHECKOUT': 'Checkout',
  'enum.paymentTransactionType.CAPTURE': 'Capture',
  'enum.paymentTransactionType.REFUND': 'Refund',
  'enum.paymentTransactionType.STATUS_SYNC': 'Status sync',
  'refunds.title': 'Refunds',
  'refunds.awaitingCount': '{count} awaiting approval',
  'refunds.description': 'Every refund, from payments and from the bar, with who asked and who decided. Refunds above the approval limit wait here for someone other than the requester.',
  'refunds.filter.all': 'All',
  'refunds.source': 'Source',
  'refunds.source.all': 'All sources',
  'refunds.source.payments': 'Memberships and payments',
  'refunds.source.bar': 'Bar',
  'refunds.bar.sale': 'Bar sale {receipt}',
  'refunds.bar.refundedBy': 'Refunded by',
  'refunds.bar.noApproval': 'Refunded at the bar, no approval needed',
  'refunds.bar.openSale': 'Open bar sale {receipt}',
  'refunds.returnPath.CASH': 'Cash is paid out at reception.',
  'refunds.returnPath.CARD_TERMINAL': 'The amount goes back to the card used at the terminal.',
  'refunds.returnPath.ONLINE': 'The amount goes back to the card used online.',
  'refunds.returnPath.BANK_TRANSFER': 'The amount is returned by bank transfer.',
  'refunds.bankPortal': 'Bank portal',
  'refunds.rejected': 'Refund request rejected',
  'refunds.approvedCompleted': 'Refund approved and completed',
  'refunds.approvedSent': 'Refund approved and sent to the provider',
  'refunds.ownRequest': 'Your request: someone else approves it',
  'refunds.approve': 'Approve',
  'refunds.reject': 'Reject',
  'refunds.showAwaiting': 'Show only the refunds awaiting approval',
  'refunds.empty.noneTitle': 'No refunds yet',
  'refunds.empty.noneDescription': 'Every refund made at the desk, from the ledger, in the bank portal or at the bar appears here, with who asked and who decided.',
  'refunds.empty.pendingTitle': 'Nothing awaiting approval',
  'refunds.empty.pendingDescription': 'Refunds above the approval limit wait here until someone other than the requester approves them.',
  'refunds.empty.filteredTitle': 'No refunds match',
  'refunds.empty.filteredDescription': 'Try another status, source or date range, or clear the filters.',
  'refunds.payment': 'Payment',
  'refunds.requestedBy': 'Requested by',
  'refunds.requested': 'Requested',
  'refunds.review': 'Review',
  'refunds.ofAmount': 'of {amount}',
  'refunds.ofAmountVia': 'of {amount} · {method} · {provider}',
  'refunds.approve.title': 'Approve refund',
  'refunds.approve.description': '{amount} of {total} goes back to {member}. {returnPath}',
  'refunds.approve.confirm': 'Approve and refund',
  'refunds.reject.title': 'Reject refund request',
  'refunds.reject.description': '{amount} for {member} stays with the gym and becomes refundable again.',
  'refunds.reject.noteRequired': 'Say why the request is rejected; the requester sees this note on the payment.',
  'refunds.reject.confirm': 'Reject request',
  'refunds.reject.required': 'Required',
  'refunds.reject.placeholder': 'Receipt shows a single charge',
  'ledger.title': 'Ledger',
  'ledger.description': 'Every payment recorded at the gym, whatever the channel.',
  'ledger.descriptionAt': 'Every payment taken at {branches}. Online payments belong to no branch, so they are not listed.',
  'ledger.searchPlaceholder': 'Search by member, member number, receipt or provider reference',
  'ledger.method': 'Method',
  'ledger.anyMethod': 'Any method',
  'ledger.anyProvider': 'Any provider',
  'ledger.empty.title': 'No payments yet',
  'ledger.empty.description': 'Payments appear here as members buy plans online or the front desk records them.',
  'ledger.empty.filteredTitle': 'No payments match',
  'ledger.empty.filteredDescription': 'Try a different search or clear the filters.',
  'ledger.planDescription': 'Plan / description',
  'ledger.online': 'Online',
};

export const ka: Record<keyof typeof en, string> = {
  'payments.page.title': 'გადახდები',
  'payments.page.description': 'ყველა თანხა, რომელიც დაკავშირებული გადახდის პროვაიდერის მეშვეობით ჩამოიჭრა.',
  'payments.page.descriptionAt': 'გადახდები, მიღებული აქ: {branches}. ონლაინ გადახდები არცერთ ფილიალს არ ეკუთვნის, ამიტომ აქ არ ჩანს.',
  'payments.anyStatus': 'ნებისმიერი სტატუსი',
  'payments.clearFilters': 'ფილტრების გასუფთავება',
  'payments.empty.title': 'გადახდები არ არის',
  'payments.empty.description': 'გადახდები გამოჩნდება, როცა წევრები პაკეტებს შეიძენენ ან აქედან ჩამოჭრით მათგან თანხას.',
  'payments.member': 'წევრი',
  'payments.description': 'აღწერა',
  'payments.amount': 'თანხა',
  'payments.provider': 'პროვაიდერი',
  'payments.details': 'დეტალები',
  'payments.syncResult': 'სტატუსი პროვაიდერთან: {status}',
  'payments.refund.title': 'გადახდის დაბრუნება',
  'payments.refund.upTo': 'შეგიძლიათ დააბრუნოთ მაქსიმუმ {amount}.',
  'payments.refund.atMost': 'დაბრუნება შესაძლებელია არაუმეტეს {amount}',
  'payments.refund.positiveAmount': 'შეიყვანეთ დადებითი თანხა',
  'payments.refund.sentForApproval': 'დაბრუნება დასამტკიცებლად გაიგზავნა',
  'payments.refund.declined': 'გადახდის პროვაიდერმა დაბრუნება უარყო. შეამოწმეთ ინტეგრაციის ჟურნალი.',
  'payments.refund.failed': 'დაბრუნება ვერ მოხერხდა',
  'payments.refund.completed': 'თანხა დაბრუნდა',
  'payments.refund.sentToProvider': 'დაბრუნების მოთხოვნა პროვაიდერს გაეგზავნა',
  'payments.refund.hint.everyRefund': 'ეს დარბაზი ყველა დაბრუნებას ამტკიცებს: ეს დაბრუნება დაელოდება, სანამ მას თქვენ გარდა სხვა მფლობელი, ადმინისტრატორი ან ბუღალტერი დაამტკიცებს, და მანამდე თანხა არ გადაირიცხება.',
  'payments.refund.hint.above': 'აღემატება დამტკიცების ლიმიტს ({limit}): ეს დაბრუნება დაელოდება, სანამ მას თქვენ გარდა სხვა მფლობელი, ადმინისტრატორი ან ბუღალტერი დაამტკიცებს, და მანამდე თანხა არ გადაირიცხება.',
  'payments.refund.hint.within': 'ჯდება დამტკიცების ლიმიტში ({limit}): ეს დაბრუნება შესრულდება, როგორც კი გაგზავნით.',
  'payments.refund.hint.cumulativeAbove': 'ამ გადახდიდან {earlier} უკვე დაბრუნებულია ან მოლოდინშია, ასე რომ, დაბრუნებების ჯამი იქნება {total}, რაც აღემატება დამტკიცების ლიმიტს ({limit}): ეს დაბრუნება დაელოდება, სანამ მას თქვენ გარდა სხვა მფლობელი, ადმინისტრატორი ან ბუღალტერი დაამტკიცებს, და მანამდე თანხა არ გადაირიცხება.',
  'payments.refund.hint.cumulativeWithin': 'ამ გადახდიდან {earlier} უკვე დაბრუნებულია ან მოლოდინშია, ასე რომ, დაბრუნებების ჯამი იქნება {total}, რაც ჯდება დამტკიცების ლიმიტში ({limit}): ეს დაბრუნება შესრულდება, როგორც კი გაგზავნით.',
  'payments.refund.request': 'დაბრუნების მოთხოვნა',
  'payments.refund.requestFull': 'სრული დაბრუნების მოთხოვნა',
  'payments.refund.amountButton': 'თანხის დაბრუნება',
  'payments.refund.full': 'სრულად დაბრუნება',
  'payments.refund.endsRenewal': 'დარჩენილი თანხის სრულად დაბრუნება გააუქმებს განახლებულ პერიოდს და გამორთავს ავტომატურ განახლებას.',
  'payments.refund.endsMembership': 'დარჩენილი თანხის სრულად დაბრუნება გააუქმებს აბონემენტს, რომელიც ამ გადახდით შეიძინეს.',
  'payments.refund.amountLabel': 'თანხა ({currency})',
  'payments.refund.amountHint': 'დატოვეთ ცარიელი, რომ დარჩენილი თანხა სრულად დაბრუნდეს.',
  'payments.refund.reasonHint': 'არასავალდებულოა, მაგრამ დამმტკიცებელს სწრაფ გადაწყვეტაში დაეხმარება.',
  'payments.charge.button': 'წევრისგან თანხის ჩამოჭრა',
  'payments.charge.title': 'წევრისგან თანხის ჩამოჭრა',
  'payments.charge.description': 'ქმნის შეკვეთას პაკეტზე და იწყებს გადახდას დაკავშირებულ პროვაიდერთან.',
  'payments.charge.viewPayment': 'გადახდის ნახვა',
  'payments.charge.create': 'გადახდის შექმნა',
  'payments.charge.sendMember': 'შესყიდვის დასასრულებლად გადაამისამართეთ წევრი გადახდის გვერდზე:',
  'payments.charge.copy': 'კოპირება',
  'payments.charge.open': 'გახსნა',
  'payments.charge.paidNow': 'გადახდა მაშინვე დასრულდა და აბონემენტი აქტიურია.',
  'payments.charge.noRedirect': 'პროვაიდერმა გადამისამართების ბმული არ დააბრუნა.',
  'payments.charge.ids': 'შეკვეთა {order}… · გადახდა {payment}…',
  'payments.charge.plan': 'პაკეტი',
  'paymentDetail.title': 'გადახდა',
  'paymentDetail.receipt': 'ქვითარი',
  'paymentDetail.invoice': 'ინვოისი',
  'paymentDetail.invoiceNumber': 'ინვოისი {number}',
  'paymentDetail.receiptNumber': 'ქვითარი {number}',
  'paymentDetail.paymentId': 'გადახდა {id}…',
  'paymentDetail.membership': 'აბონემენტი',
  'paymentDetail.syncStatus': 'სტატუსის განახლება',
  'paymentDetail.refund': 'თანხის დაბრუნება',
  'paymentDetail.providerReference': 'პროვაიდერის იდენტიფიკატორი',
  'paymentDetail.created': 'შექმნის დრო',
  'paymentDetail.paid': 'გადახდის დრო',
  'paymentDetail.refunded': 'დაბრუნებული',
  'paymentDetail.pendingRefunds': 'მოლოდინში მყოფი დაბრუნებები',
  'paymentDetail.failure': 'წარუმატებლობის მიზეზი',
  'paymentDetail.recordedBy': 'ვინ დააფიქსირა',
  'paymentDetail.selfService': 'ონლაინ / თვითმომსახურება',
  'paymentDetail.soldByChange': 'შეცვლა',
  'paymentDetail.soldByHint': 'ცვლილება მთელ შეძენას ეხება: მისი ყველა გადახდა ახალ გამყიდველს ჩაეთვლება.',
  'paymentDetail.soldByChanged': 'გამყიდველი შეიცვალა',
  'paymentDetail.waiting': 'ველოდებით, რომ წევრმა გადახდა დაასრულოს.',
  'paymentDetail.openPaymentPage': 'გადახდის გვერდის გახსნა',
  'paymentDetail.copyLink': 'ბმულის კოპირება',
  'paymentDetail.transactions': 'ტრანზაქციები',
  'paymentDetail.noTransactions': 'ტრანზაქციები არ დაფიქსირებულა.',
  'paymentDetail.when': 'დრო',
  'paymentDetail.type': 'ტიპი',
  'paymentDetail.reference': 'იდენტიფიკატორი',
  'paymentDetail.refunds': 'დაბრუნებები',
  'paymentDetail.noRefunds': 'დაბრუნებები არ არის.',
  'paymentDetail.noReason': 'მიზეზი მითითებული არ არის',
  'paymentDetail.requested': 'მოთხოვნილია {requested}',
  'paymentDetail.requestedReviewed': 'მოთხოვნილია {requested} · განხილულია {reviewed}',
  'paymentDetail.reviewNote': 'განხილვის შენიშვნა:',
  'enum.paymentTransactionType.CHECKOUT': 'გადახდის ინიცირება',
  'enum.paymentTransactionType.CAPTURE': 'თანხის ჩამოჭრა',
  'enum.paymentTransactionType.REFUND': 'დაბრუნება',
  'enum.paymentTransactionType.STATUS_SYNC': 'სტატუსის სინქრონიზაცია',
  'refunds.title': 'დაბრუნებები',
  'refunds.awaitingCount': '{count} ელოდება დამტკიცებას',
  'refunds.description': 'ყველა დაბრუნება, გადახდებიდან და ბარიდან: ვინ მოითხოვა და ვინ გადაწყვიტა. დამტკიცების ლიმიტზე მეტი დაბრუნებები აქ ელოდება, სანამ მათ მომთხოვნის გარდა სხვა ვინმე დაამტკიცებს.',
  'refunds.filter.all': 'ყველა',
  'refunds.source': 'წყარო',
  'refunds.source.all': 'ყველა წყარო',
  'refunds.source.payments': 'აბონემენტები და გადახდები',
  'refunds.source.bar': 'ბარი',
  'refunds.bar.sale': 'ბარის გაყიდვა {receipt}',
  'refunds.bar.refundedBy': 'ვინ დააბრუნა',
  'refunds.bar.noApproval': 'დაბრუნდა ბარში, დამტკიცება არ სჭირდება',
  'refunds.bar.openSale': 'ბარის გაყიდვის {receipt} გახსნა',
  'refunds.returnPath.CASH': 'ნაღდი ფული გაიცემა მიმღებში.',
  'refunds.returnPath.CARD_TERMINAL': 'თანხა დაბრუნდება ბარათზე, რომლითაც ტერმინალში გადაიხადეს.',
  'refunds.returnPath.ONLINE': 'თანხა დაბრუნდება ბარათზე, რომლითაც ონლაინ გადაიხადეს.',
  'refunds.returnPath.BANK_TRANSFER': 'თანხა დაბრუნდება საბანკო გადარიცხვით.',
  'refunds.bankPortal': 'ბანკის პორტალი',
  'refunds.rejected': 'დაბრუნების მოთხოვნა უარყოფილია',
  'refunds.approvedCompleted': 'დაბრუნება დამტკიცდა და შესრულდა',
  'refunds.approvedSent': 'დაბრუნება დამტკიცდა და პროვაიდერს გაეგზავნა',
  'refunds.ownRequest': 'თქვენი მოთხოვნაა: მას სხვა დაამტკიცებს',
  'refunds.approve': 'დამტკიცება',
  'refunds.reject': 'უარყოფა',
  'refunds.showAwaiting': 'მხოლოდ დასამტკიცებელი დაბრუნებების ჩვენება',
  'refunds.empty.noneTitle': 'დაბრუნებები ჯერ არ ყოფილა',
  'refunds.empty.noneDescription': 'მიმღებში, რეესტრიდან, ბანკის პორტალში ან ბარში გაკეთებული ყველა დაბრუნება აქ ჩანს: ვინ მოითხოვა და ვინ გადაწყვიტა.',
  'refunds.empty.pendingTitle': 'დასამტკიცებელი არაფერია',
  'refunds.empty.pendingDescription': 'დამტკიცების ლიმიტზე მეტი დაბრუნებები აქ ელოდება, სანამ მათ მომთხოვნის გარდა სხვა ვინმე დაამტკიცებს.',
  'refunds.empty.filteredTitle': 'შესაბამისი დაბრუნებები არ მოიძებნა',
  'refunds.empty.filteredDescription': 'სცადეთ სხვა სტატუსი, წყარო ან თარიღების დიაპაზონი, ან გაასუფთავეთ ფილტრები.',
  'refunds.payment': 'გადახდა',
  'refunds.requestedBy': 'ვინ მოითხოვა',
  'refunds.requested': 'მოთხოვნა',
  'refunds.review': 'განხილვა',
  'refunds.ofAmount': '{amount}-დან',
  'refunds.ofAmountVia': '{amount}-დან · {method} · {provider}',
  'refunds.approve.title': 'დაბრუნების დამტკიცება',
  'refunds.approve.description': 'წევრს ({member}) დაუბრუნდება {amount} {total}-დან. {returnPath}',
  'refunds.approve.confirm': 'დამტკიცება და დაბრუნება',
  'refunds.reject.title': 'დაბრუნების მოთხოვნის უარყოფა',
  'refunds.reject.description': 'თანხა {amount} (წევრი: {member}) რჩება დარბაზს და მისი დაბრუნება კვლავ შესაძლებელი იქნება.',
  'refunds.reject.noteRequired': 'მიუთითეთ, რატომ უარყავით მოთხოვნა; მომთხოვნი ამ შენიშვნას გადახდაზე დაინახავს.',
  'refunds.reject.confirm': 'მოთხოვნის უარყოფა',
  'refunds.reject.required': 'სავალდებულო',
  'refunds.reject.placeholder': 'ქვითარზე მხოლოდ ერთი ჩამოჭრაა',
  'ledger.title': 'რეესტრი',
  'ledger.description': 'დარბაზში დაფიქსირებული ყველა გადახდა, არხის მიუხედავად.',
  'ledger.descriptionAt': 'ყველა გადახდა, მიღებული აქ: {branches}. ონლაინ გადახდები არცერთ ფილიალს არ ეკუთვნის, ამიტომ აქ არ ჩანს.',
  'ledger.searchPlaceholder': 'მოძებნეთ წევრით, წევრის ნომრით, ქვითრით ან პროვაიდერის იდენტიფიკატორით',
  'ledger.method': 'მეთოდი',
  'ledger.anyMethod': 'ნებისმიერი მეთოდი',
  'ledger.anyProvider': 'ნებისმიერი პროვაიდერი',
  'ledger.empty.title': 'გადახდები ჯერ არ არის',
  'ledger.empty.description': 'გადახდები აქ გამოჩნდება, როცა წევრები პაკეტებს ონლაინ შეიძენენ ან მიმღები მათ დააფიქსირებს.',
  'ledger.empty.filteredTitle': 'შესაბამისი გადახდები არ მოიძებნა',
  'ledger.empty.filteredDescription': 'სცადეთ სხვა ძებნა ან გაასუფთავეთ ფილტრები.',
  'ledger.planDescription': 'პაკეტი / აღწერა',
  'ledger.online': 'ონლაინ',
};
